// extracted by mini-css-extract-plugin
module.exports = {"dialog":"BaseContent_dialog__1t6j6","dialogContent":"BaseContent_dialogContent__3lPVF","closeButton":"BaseContent_closeButton__mRVxA"};